(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
function initTepelaAutoRelated(){
 document.querySelectorAll('.tp-related-two-rows[data-tp-related-auto="true"]').forEach(function(root){
  var track=root.querySelector('.tp-related-two-row-track');
  if(!track||track.dataset.tpAutoReady)return;
  track.dataset.tpAutoReady='true';
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(reduced.matches)return;
  var cards=Array.from(track.children).filter(function(card){return card.matches('article');});
  if(cards.length<3||(getComputedStyle(root).getPropertyValue('--tp-related-rows').trim()!=='1'&&cards.length%2!==0))return;
  var firstClone=null;
  cards.forEach(function(card){var copy=card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.dataset.tpAutoClone='true';copy.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id');});copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){el.tabIndex=-1;});track.appendChild(copy);if(!firstClone)firstClone=copy;});
  track.classList.add('tp-auto-related-track');
  var distance=0,position=track.scrollLeft,last=0,hover=false,focused=false,visible=true,pauseUntil=0;
  var speed=Number(root.dataset.tpScrollSpeed)||18;
  function measure(){distance=firstClone.offsetLeft-cards[0].offsetLeft;}
  measure();
  var resize=new ResizeObserver(measure);resize.observe(track);
  var intersection=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;},{threshold:0.05});intersection.observe(track);
  track.addEventListener('pointerenter',function(){hover=true;});track.addEventListener('pointerleave',function(){hover=false;});
  track.addEventListener('focusin',function(){focused=true;});track.addEventListener('focusout',function(){focused=track.contains(document.activeElement);});
  function pause(){pauseUntil=performance.now()+3500;}
  track.addEventListener('pointerdown',pause);track.addEventListener('touchstart',pause,{passive:true});track.addEventListener('touchmove',pause,{passive:true});track.addEventListener('wheel',pause,{passive:true});track.addEventListener('keydown',pause);
  function tick(time){
   if(!track.isConnected){resize.disconnect();intersection.disconnect();return;}
   var elapsed=last?Math.min(time-last,50):0;last=time;
   if(!document.hidden&&visible&&!hover&&!focused&&time>pauseUntil&&!reduced.matches&&distance>0){position+=speed*elapsed/1000;if(position>=distance)position-=distance;track.scrollLeft=position;}else{position=track.scrollLeft;if(position>=distance&&distance>0)position-=distance;}
   requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
 });
}
initTepelaAutoRelated();
document.addEventListener('DOMContentLoaded',initTepelaAutoRelated);document.addEventListener('shopify:section:load',initTepelaAutoRelated);
var tepelaAutoObserverQueued=false;
new MutationObserver(function(){if(tepelaAutoObserverQueued)return;tepelaAutoObserverQueued=true;requestAnimationFrame(function(){tepelaAutoObserverQueued=false;initTepelaAutoRelated();});}).observe(document.documentElement,{childList:true,subtree:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tepela-catalog-directory"] && !Shopify.designMode) return;
  try {
    
function initTepelaDirectory(scope) {
  scope.querySelectorAll('[data-tp-directory]').forEach(function(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    var input=root.querySelector('[data-tp-category-search]');
    if(!input) return;
    root.querySelector('.tp-directory-tools').hidden=false;
    input.addEventListener('input',function() {
      var words=input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      var shown=0;
      root.querySelectorAll('[data-tp-category-card]').forEach(function(card) {
        var text=card.querySelector('[data-tp-card-title]').textContent.toLocaleLowerCase();
        card.hidden=!words.every(function(word){return text.indexOf(word)!==-1;});
        if(!card.hidden) shown++;
      });
      root.querySelectorAll('[data-tp-category-group]').forEach(function(group) {
        group.hidden=!group.querySelector('[data-tp-category-card]:not([hidden])');
      });
      root.querySelector('[data-tp-category-empty]').hidden=shown!==0;
      root.querySelector('[data-tp-category-status]').textContent=shown+' '+root.dataset.resultLabel;
    });
  });
}
initTepelaDirectory(document);
document.addEventListener('shopify:section:load',function(){initTepelaDirectory(document);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tepela-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.tp-mobile-menu a,.tp-catalog-menu a');
  if(link){document.querySelectorAll('.tp-mobile-menu[open],.tp-catalog-menu[open]').forEach(function(menu){menu.removeAttribute('open');});}
  document.querySelectorAll('.tp-catalog-menu[open],.tp-mobile-menu[open]').forEach(function(menu){if(!menu.contains(event.target)){menu.removeAttribute('open');}});
});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.tp-catalog-menu[open],.tp-mobile-menu[open]').forEach(function(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();
})();
